import * as tslib_1 from "tslib";
import { LineMapperService } from '../../../../core/components/charts/line/services/line.mapper.service';
import { RatingsService } from './api/ratings-api.service';
import { RatingsMapperService } from './ratings.mapper.service';
import * as i0 from "@angular/core";
import * as i1 from "./api/ratings-api.service";
import * as i2 from "../../../../core/components/charts/line/services/line.mapper.service";
import * as i3 from "./ratings.mapper.service";
var RatingsResolverService = /** @class */ (function () {
    function RatingsResolverService(api, lineChartMapper, ratingsMapper) {
        this.api = api;
        this.lineChartMapper = lineChartMapper;
        this.ratingsMapper = ratingsMapper;
    }
    RatingsResolverService.prototype.getAccountRatingsAverageByTimeline = function (where) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.accountRatingsAverageLineChart(where)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    RatingsResolverService.prototype.getBestRatings = function (where) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.getRatedTasks({ where: where, orderBy: 'ratingStars_desc', ratingIn: [3, 4, 5] })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    RatingsResolverService.prototype.getWorstRatings = function (where) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.getRatedTasks({ where: where, orderBy: 'ratingStars_asc', ratingIn: [0, 1, 2] })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    RatingsResolverService.prototype.getRatingsByQuantity = function (where) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ratingsByQuantity;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.getRatingsByQuantity(where)];
                    case 1:
                        ratingsByQuantity = _a.sent();
                        return [2 /*return*/, this.ratingsMapper.convertRatingsByQuantityData(ratingsByQuantity)];
                }
            });
        });
    };
    RatingsResolverService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RatingsResolverService_Factory() { return new RatingsResolverService(i0.ɵɵinject(i1.RatingsService), i0.ɵɵinject(i2.LineMapperService), i0.ɵɵinject(i3.RatingsMapperService)); }, token: RatingsResolverService, providedIn: "root" });
    return RatingsResolverService;
}());
export { RatingsResolverService };
